module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av553-db053cb4dabc42e7045ceb8a27ac5ca8.jpg";